const Status= Object.freeze({
    0: "Beschikbaar",
    1: "Onderweg",
    2: "In gebruik",
    3: "Defect"
});

export default Status;